
import { Options, Vue } from "vue-class-component"; //基本需要\
import { reactive, ref } from "vue";
import SideMenu from "@/components/WorkBench/SideMenu.vue"; //导入组件SideMenu:1
import Bs from "@/components/WorkBench/SideMenu1.vue"; //导入组件SideMenu:1
import "@/assets/iconfont/font_3410179_7jzi7zxz4zw/iconfont.css"; //引入仓库
import {
  dateConversion,
  getLocalProject,
  saveLocalProject,
  saveLocalStorageProject,
  typeConversion,
} from "@/utils"; //类型
import { ElMessage } from "element-plus";
import * as echarts from "echarts";
import { store } from "@/store"; //引入仓库
import {
  readGetResourceDates,
  readGetResourceRecords,
  readGetResourceVersions,
  readGetResourceDevices,
  readGetResourceScenes,
  readGetResourceId,
  readGetResourceCarList,
  readGetResourceCarData,
  readGetResourceOverall,
  readGetResourceAverageData,
  readGetResourceChart,
  readGetResourceLoadList,
  readGetResourceSkinList,
  readGetResourceChartAvg,
  readGetResourceTypeList,
  readGetResourceHistory,
} from "@/store/performance/getters"; //引入仓库接口
import {
  dispatchResourceScanDates,
  dispatchResourceScanRecords,
  dispatchResourceScanVersions,
  dispatchResourceScanDevices,
  dispatchResourceScanScenes,
  dispatchResourceScanId,
  dispatchResourceScanCarList,
  dispatchResourceScanCarData,
  dispatchResourceOverall,
  dispatchResourceScanAverageData,
  dispatchResourceScanChart,
  dispatchResourceScanLoadList,
  dispatchResourceScanSkinList,
  dispatchResourceScanChartAvg,
  dispatchResourceScanTypeList,
  dispatchResourceHistory,
} from "@/store/performance/actions";
import { readDeviceSpecs } from "@/store/device/getters";
import { dispatchGetDeviceSpecs } from "@/store/device/actions";
import {
  dispatchGetProjectDetail,
  dispatchGetProjectScenes,
} from "@/store/project/actions";
import _FormItem from "element-plus/lib/el-form-item";
import {
  readHeroSkin,
  readMobaProjects,
  readUserProfile,
} from "@/store/main/getters";
import {
  dispatchGetHeroSkin,
  dispatchGetMobaProjects,
  dispatchUpdateMyLastProject,
} from "@/store/main/actions";
import { readMyProjects, readProjectDetail } from "@/store/project/getters";
import fileSaver from "file-saver";
import * as XLSX from "xlsx";

// 导入组件SideMenu:2
@Options({
  components: {
    Bs,
  },
})
export default class TestReport extends Vue {
  //声明属性
  public carLoading = false;
  public localProject = Number(getLocalProject()); //得到本地的项目
  public get date_list() {
    return readGetResourceDates(store);
  }
  public async history_api() {
    await dispatchResourceHistory(store, {
      project: this.localProject,
      car_name: this.car_name,
    });
    const avg_list = ["avg_dc", "avg_tris"];
    avg_list.forEach((v) => {
      this.drawHistory(v + "_line");
    });
  }
  public async skin_name_api() {
    await dispatchResourceScanSkinList(store, {
      project: this.localProject,
      car_name: this.car_name,
      id_test: this.id_test,
      scan_type: this.scan_type,
      lod_name: this.lod_name,
    });
    this.skin_name = this.skin_name_list[0];
  }
  public drawHistory(item) {
    let data: any = [];

    let performance_line: any = document.getElementById(item);
    echarts.dispose(performance_line);
    var contrastChart = echarts.init(performance_line);
    contrastChart.setOption({
      tooltip: {
        trigger: "axis",
      },

      legend: {
        type: "scroll",
        x: "center",
        y: "bottom",
        padding: [0, 0, 10, 0],
        // data: devices.map(
        //   (item) =>
        //     this.getDeviceSpecs.filter(
        //       (device) => device.id === item.device_id
        //     )[0]?.model.name
        // ),
      },
      yAxis: {
        type: "value",
        name: "MB",
        //  nameLocation: "top",
        // 坐标轴名称与轴线之间的距离。
        // nameGap: 35,
        // nameRotate: 90,
        axisTick: false,
        //左侧线
        // axisLine: {
        //   show: true,
        // },
        //  splitLine: {
        //   show: true,
        // },
      },
      grid: {
        left: "4%",
        top: "10%",
        bottom: "10%",
        right: "4%",
        containLabel: true,
      },
      animation: false,
      xAxis: {
        type: "category",
        data: this.history_data.date,
      },

      series:
        item == "avg_dc_line"
          ? this.formatDataForECharts(this.history_data_all).sum_dc
          : this.formatDataForECharts(this.history_data_all).sum_tris,
    });
  }
  public skin_name = "";
  public get test_list() {
    return readGetResourceRecords(store);
  }
  public get history_data_all() {
    return readGetResourceHistory(store);
  }
  public get history_data() {
    return {
      date: Object.keys(this.history_data_all),
    };
  }
  formatDataForECharts(rawData) {
    // 初始化结果
    const sumDc = {};
    const sumTris = {};
    const dates = Object.keys(rawData);

    // 提取数据
    dates.forEach((date) => {
      Object.keys(rawData[date]).forEach((key) => {
        if (!sumDc[key]) {
          sumDc[key] = [];
        }
        if (!sumTris[key]) {
          sumTris[key] = [];
        }

        sumDc[key].push(rawData[date][key].sum_dc ?? null);
        sumTris[key].push(rawData[date][key].sum_tris ?? null);
      });
    });

    // 格式化为 ECharts 所需的数据
    const formattedSumDc = Object.keys(sumDc).map((name) => ({
      name,
      data: sumDc[name],
      type: "line",
      smooth: true, // 平滑曲线
      symbol: "circle", //拐点设置为实心
      itemStyle: {
        normal: {
          label: {
            // show: this.getFPS_RawData.device_names.length <= 3 ? true : false,
            show: true,
          },
        },
      },
    }));

    const formattedSumTris = Object.keys(sumTris).map((name) => ({
      name,
      data: sumTris[name],
      type: "line",
      smooth: true, // 平滑曲线
      symbol: "circle", //拐点设置为实心
      itemStyle: {
        normal: {
          label: {
            // show: this.getFPS_RawData.device_names.length <= 3 ? true : false,
            show: true,
          },
        },
      },
    }));

    return {
      sum_dc: formattedSumDc,
      sum_tris: formattedSumTris,
    };
  }
  public get version_list() {
    return readGetResourceVersions(store);
  }
  public get device_list() {
    return readGetResourceDevices(store);
  }
  public get scene_list() {
    return readGetResourceScenes(store);
  }
  public get load_name_data() {
    return readGetResourceLoadList(store);
  }
  public lod_name = "";
  public get resource_id() {
    return readGetResourceId(store);
  }
  public get car_list() {
    return readGetResourceCarList(store);
  }
  public get car_data() {
    return readGetResourceCarData(store);
  }
  public car_name = "";
  public date = "";
  public record_id = "";
  public version = "";
  public device_name = "";
  public scene_name = "";
  public id_test = "";
  public size = 20;
  public page = 1;
  public get overAllData() {
    return readGetResourceOverall(store);
  }
  public get averageData() {
    console.log(readGetResourceAverageData(store));
    return readGetResourceAverageData(store);
  }
  public get averageAvg_dc_device() {
    const device = Object.keys(this.averageData.avg_dc_data);
    return device;
  }
  public get averageAvg_dc_date() {
    return Object.keys(
      this.averageData.avg_dc_data[this.averageAvg_dc_device[0]]
    );
  }
  public get averageAvg_tris_device() {
    const device = Object.keys(this.averageData.avg_tris_data);
    return device;
  }
  public get averageAvg_tris_date() {
    return Object.keys(
      this.averageData.avg_tris_data[this.averageAvg_tris_device[0]]
    );
  }
  public get averageAvg_dc_series() {
    const colorPairs = [
      ["rgb(0, 221, 255)", "rgb(77, 119, 255)"],
      ["rgb(255, 0, 135)", "rgb(135, 0, 255)"],
      ["rgb(255, 191, 0)", "rgb(255, 48, 79)"],
      // 更多颜色组合
    ];
    function getColor(index: number) {
      const colors = colorPairs[index % colorPairs.length];
      return new echarts.graphic.LinearGradient(0, 0, 0, 1, [
        { offset: 0, color: colors[0] },
        { offset: 1, color: colors[1] },
      ]);
    }
    return this.averageAvg_dc_device.map((v, index) => ({
      name: v,
      type: "line",
      stack: "Total",
      smooth: true,
      lineStyle: {
        width: 0,
      },
      showSymbol: false,
      emphasis: {
        focus: "series",
      },
      areaStyle: {
        opacity: 0.8,
        color: getColor(index), // 使用函数返回渐变颜色
      },
      data: Object.values(this.averageData.avg_dc_data[v]).map(
        (item: any) => item.avg_dc
      ),
    }));
  }
  public get averageAvg_tris_series() {
    const colorPairs = [
      ["rgb(0, 221, 255)", "rgb(77, 119, 255)"],
      ["rgb(255, 0, 135)", "rgb(135, 0, 255)"],
      ["rgb(255, 191, 0)", "rgb(255, 48, 79)"],
      // 更多颜色组合
    ];
    function getColor(index: number) {
      const colors = colorPairs[index % colorPairs.length];
      return new echarts.graphic.LinearGradient(0, 0, 0, 1, [
        { offset: 0, color: colors[0] },
        { offset: 1, color: colors[1] },
      ]);
    }
    return this.averageAvg_tris_device.map((v, index) => ({
      name: v,
      type: "line",
      stack: "Total",
      smooth: true,
      lineStyle: {
        width: 0,
      },
      showSymbol: false,
      emphasis: {
        focus: "series",
      },
      areaStyle: {
        opacity: 0.8,
        color: getColor(index), // 使用函数返回渐变颜色
      },
      data: Object.values(this.averageData.avg_tris_data[v]).map(
        (item: any) => item.avg_tris
      ),
    }));
  }
  public drawBoxplot(containerId) {
    let performance_line: any = document.getElementById(containerId);
    echarts.dispose(performance_line);
    var contrastChart = echarts.init(performance_line);
    contrastChart.setOption({
      tooltip: {
        trigger: "item",
      },
      grid: {
        left: "10%",
        right: "10%",
        bottom: "10%",
        containLabel: false,
      },
      xAxis: {
        type: "category",
        data: ["A", "B", "C", "D", "E"],
      },
      yAxis: {
        type: "value",
      },
      series: [
        {
          name: "盒须图",
          type: "boxplot",
          data: [
            [1, 2, 3, 4, 5],
            [2, 3, 4, 5, 6],
            [3, 4, 5, 6, 7],
            [4, 5, 6, 7, 8],
            [5, 6, 7, 8, 9],
          ],
        },
      ],
    });
  }
  public front = 75;
  public behind = 25;
  public get overxAxis() {
    let list = Object.keys(this.overAllData.max_min_dc_by_type);
    return list;
  }
  public get overSeries() {
    let list = [];
    this.overxAxis.forEach((v) => {
      let data_store = this.overAllData.max_min_dc_by_type[v];
      list.push({
        name: v,
        type: "boxplot",
        data:
          100 - this.behind > this.front
            ? [
                [
                  data_store.min_dc_total,
                  data_store.front_dc_data.total_dc,
                  data_store.median_dc,
                  data_store.behind_dc_data.total_dc,
                  data_store.max_dc_total,
                ],
              ]
            : [
                [
                  data_store.min_dc_total,
                  data_store.behind_dc_data.total_dc,
                  data_store.median_dc,
                  data_store.front_dc_data.total_dc,
                  data_store.max_dc_total,
                ],
              ],
      });
    });
    return list;
  }
  public drawAvg(item) {
    let performance_line: any = document.getElementById(item);
    echarts.dispose(performance_line);
    var contrastChart = echarts.init(performance_line);
    contrastChart.setOption({
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "cross",
          label: {
            backgroundColor: "#6a7985",
          },
        },
      },
      legend: {
        data:
          item == "avg_dc"
            ? this.averageAvg_dc_device
            : this.averageAvg_tris_device,
        // 将图例水平居中
        x: "center",
        y: "bottom",
        padding: [0, 0, 10, 0],
      },
      grid: {
        left: "4%",
        top: "10%",
        bottom: "10%",
        right: "4%",
        containLabel: true,
      },
      xAxis: {
        type: "category",
        data:
          item == "avg_dc"
            ? this.averageAvg_dc_date
            : this.averageAvg_tris_date,
      },
      yAxis: {
        type: "value",
      },
      series:
        item == "avg_dc"
          ? this.averageAvg_dc_series
          : this.averageAvg_tris_series,
    });
  }
  public drawAvgColumn(item) {
    let performance_line: any = document.getElementById(item);
    echarts.dispose(performance_line);
    var contrastChart = echarts.init(performance_line);
    console.log("Data for avg_dc:", this.avg_column_series[0]);
    console.log("Data for other:", this.avg_column_series[1]);
    console.log(
      item,
      item == "avg_dc"
        ? [this.avg_column_series[0]]
        : [this.avg_column_series[1]]
    );
    contrastChart.setOption({
      tooltip: {
        trigger: "axis",
      },
      legend: {
        // 将图例水平居中
        x: "center",
        y: "bottom",
        padding: [0, 0, 10, 0],
      },
      grid: {
        left: "4%",
        top: "10%",
        bottom: "10%",
        right: "4%",
        containLabel: true,
      },
      xAxis: {
        type: "category",
        data: this.series_avg.date,
      },
      yAxis: {
        type: "value",
      },
      series:
        item == "avg_dc_column"
          ? [this.avg_column_series[0]]
          : [this.avg_column_series[1]],
    });
  }
  public get piechartData() {
    return readGetResourceChart(store);
  }
  public drawResPie(item) {
    let performance_line: any = document.getElementById(item);
    echarts.dispose(performance_line);
    var contrastChart = echarts.init(performance_line);
    contrastChart.setOption({
      title: {
        text:
          "总大小" +
          (item == "avg_dc_pie"
            ? this.piechartData.reduce(
                (accumulator, current) => accumulator + current.DC_Percent,
                0
              )
            : this.piechartData.reduce(
                (accumulator, current) => accumulator + current.Tris_Percent,
                0
              )),

        left: "center",
      },

      animation: false,
      // backgroundColor: 'rgb(13, 13, 13)',
      tooltip: {
        trigger: "item",
        // formatter: (params: any) => {
        //   var str = "";
        //   //首先要看看params是怎样的数据结构，里面有什么内容;

        //   //对params进行操作
        //   return (
        //     params.data.name +
        //     ":" +
        //     this.sizeCompany(params.data.value) +
        //     "(" +
        //     params.percent +
        //     "%)"
        //   );
        // },
      },

      series: [
        {
          type: "pie",
          radius: "80%",
          center: ["50%", "58%"], // 调整饼图的位置
          data:
            item == "avg_dc_pie"
              ? this.piechartData.map((item) => {
                  return { name: item.Part_Name, value: item.DC_Percent };
                })
              : this.piechartData.map((item) => {
                  return { name: item.Part_Name, value: item.Tris_Percent };
                }),
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)",
            },
          },
          itemStyle: {
            normal: {
              label: {
                show: true,
                formatter: "{d}%",
                position: "inside",
                color: "#fff",
              },
              labelLine: { show: false },
            },
          },
        },
      ],
    });
  }
  public get type_list() {
    return readGetResourceTypeList(store);
  }
  public async detailChange(item) {
    if (item.includes("car")) {
      await this.car_list_api();
    }
    if (item.includes("load")) {
      await this.load_list_api();
    }
    if (item.includes("skin")) {
      await this.skin_name_api();
    }
  }
  public async pie_chart_api() {
    await dispatchResourceScanChart(store, {
      project: this.localProject,
      scan_type: this.scan_type,
      car_name: this.car_name,
      // front:75,
      // behind:25
    });

    const avg_list = ["avg_dc", "avg_tris"];
    avg_list.forEach((v) => {
      this.drawResPie(v + "_pie");
    });
  }
  public async column_chart_api() {
    await dispatchResourceScanChartAvg(store, {
      project: this.localProject,
      scan_type: this.scan_type,
      car_name: this.car_name,
    });
    const avg_list = ["avg_dc", "avg_tris"];
    avg_list.forEach((v) => {
      this.drawAvgColumn(v + "_column");
    });
  }
  public get column_data() {
    return readGetResourceChartAvg(store);
  }
  public get series_avg() {
    let data = {
      date: this.column_data.total_avgs.map((v) => v.Part_Name),
      avg_dc: this.column_data.total_avgs.map((v) => v.avg_dc),
      avg_tris: this.column_data.total_avgs.map((v) => v.avg_tris),
    };
    return data;
  }
  public get avg_column_series() {
    return [
      { name: "avg_dc", data: this.series_avg.avg_dc, type: "bar" },
      { name: "avg_tris", data: this.series_avg.avg_tris, type: "bar" },
    ];
  }
  public async over_api() {
    await dispatchResourceScanAverageData(store, {
      project: this.localProject,
      // front:75,
      // behind:25
    });
    const avg_list = ["avg_dc", "avg_tris"];
    avg_list.forEach((v) => {
      this.drawAvg(v);
    });
  }
  public scan_type = "";
  public async mounted() {
    this.carLoading = true;
    // await dispatchResourceScanTypeList(store, {
    //   project: this.localProject,
    // });

    // this.scan_type = this.type_list[0].value;
    this.over_api();

    
    // this.pie_chart_api();
    // this.column_chart_api();
    // this.history_api();
    //  await dispatchResourceScanChart(store,{
    //     project:this.localProject,
    //     scan_type:this.scan_type,
    //     car_name:this.car_name
    //     // front:75,
    //     // behind:25
    //   })

    //   const avg_list=['avg_dc','avg_tris']
    //   avg_list.forEach((v=>{
    //     this.drawAvg(v)
    //     this.drawResPie(v+'_pie')
    //   }))

    // await dispatchResourceScanDates(store, {
    //   project: this.localProject,
    // });
    // this.date = this.date_list[0];
    // await this.options_api(["test_id", "records", "device", "scene"]);
    // await this.detailChange(["car", "load", "skin"]);
    // //  await  this.car_list_api()
    // //  await this.load_list_api()
    // //  await  this.skin_name_api()

    // this.source_current_change(true);
  }
  public get skin_name_list() {
    return readGetResourceSkinList(store);
  }
  public async load_list_api() {
    await dispatchResourceScanLoadList(store, {
      project: this.localProject,
      car_name: this.car_name,
      id_test: this.id_test,
      scan_type: this.scan_type,
    });
    this.lod_name = this.load_name_data[0];
  }
  public async confirm() {
    await this.car_list_api();
    await this.detailChange(["car", "load", "skin"]);
    this.source_current_change(true);
  }
  public async car_list_api() {
    await dispatchResourceScanCarList(store, {
      project: this.localProject,
      id_test: this.id_test,
      scan_type: this.scan_type,
    });
    this.car_name = this.car_list[0];
  }
  public source_current_change(type) {
    this.carLoading = true;
    this.page = type ? 1 : this.page;
    this.car_list_data();
  }
  public async car_list_data() {
    await dispatchResourceScanCarData(store, {
      project: this.localProject,
      id_test: this.id_test,
      car_name: this.car_name,
      size: this.size,
      page: this.page,
      scan_type: this.scan_type,
      lod_name: this.lod_name,
      skin_name: this.skin_name,
    });
    this.carLoading = false;
  }
  public async options_api(item) {
    if (item.includes("test_id")) {
      await dispatchResourceScanRecords(store, {
        project: this.localProject,
        date: this.date,
      });
      this.record_id = this.test_list[0].record_id;
    }
    if (item.includes("records")) {
      await dispatchResourceScanVersions(store, {
        project: this.localProject,
        date: this.date,
        record_id: this.record_id,
      });
      this.version = this.version_list[0].version;
    }
    if (item.includes("device")) {
      await dispatchResourceScanDevices(store, {
        project: this.localProject,
        date: this.date,
        record_id: this.record_id,
        version: this.version,
      });
      this.device_name = this.device_list[0];
    }
    if (item.includes("scene")) {
      await dispatchResourceScanScenes(store, {
        project: this.localProject,
        date: this.date,
        record_id: this.record_id,
        version: this.version,
        device_name: this.device_name,
      });
      this.scene_name = this.scene_list[0].scene_name;
    }

    await dispatchResourceScanId(store, {
      project: this.localProject,
      date: this.date,
      record_id: this.record_id,
      version: this.version,
      device_name: this.device_name,
      scene_name: this.scene_name,
    });
    this.id_test = this.resource_id.id_test;
  }
}
